import React, { useState, useEffect } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  Card,
  CardBody,
  FormGroup,
  Button,
} from "react-bootstrap";
import {
  IconAlertCircle,
  IconAlertOctagon,
  IconCurrencyDollar,
  IconFileText,
  IconFileTypeXls,
  IconUser,
} from "@tabler/icons-react";
import Select from "react-select";
import { toast } from "react-toastify";
import ExtractData from "./ExtractData";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { useNavigate } from "react-router-dom";
import { useFormContext } from "react-hook-form";
import { useForm } from "react-hook-form";

function BulkPorduct() {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const options = ["Add Individually", "Bulk Upload"];
  const [currentOption, setCurrentOption] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionSimple, setSelectedOptionSimple] = useState(null);
  const [errors, setErrors] = useState({
    vendor: "",
    skuId: "",
    name: "",
    aspettoPrice: "",
    customerPrice: "",
    description: "",
    uoi: "",
  });
  const { register, setValue, handleSubmit, watch } = useForm();

  const { isLoadingBulk, postData: postDataBULK } = usePostRequest(
    API_ENDPOINTS.BULK_UPLOAD_PRODUCT
  );

  const ProductTypeSelected = watch("Type");

  useEffect(() => {
    if (!ProductTypeSelected) {
      setValue("Type", "inventory");
    }
  }, [setValue, ProductTypeSelected]);

  const {
    data: fetchContractdata,
    isLoading: contractLoading,
    postData: fetchContract,
  } = usePostRequest(API_ENDPOINTS.GET_CONTRACT);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  useEffect(() => {
    fetchContract();
  }, []);

  const handleDownload = () => {
    const publicUrl = process.env.REACT_APP_PUBLIC_URL;
    const link = document.createElement("a");
    link.href = `${publicUrl}/template.xlsx`;
    link.download = "template.xlsx";
    link.click();
  };

  const onError = (error) => {
    if (error.errors) {
      toast.error(error.message);
      setErrors({
        vendor: error.errors.vendor_id ? error.errors.vendor_id.message : "",
        skuId: error.errors.sku_id ? error.errors.sku_id.message : "",
        aspettoPrice: error.errors.aspetto_price
          ? error.errors.aspetto_price.message
          : "",
        customerPrice: error.errors.customer_price
          ? error.errors.customer_price.message
          : "",
        description: error.errors.description
          ? error.errors.description.message
          : "",
        name: error.errors.name ? error.errors.name.message : "",
      });
    }
  };

  const onSuccess = (response) => {
    if (response) {
      toast.success(response.message);
    }
    navigate("/products-list");
  };

  const handleExtractData = async () => {
    const BATCH_SIZE = 50;
    try {
      if (!file) {
        toast.error("Please select a file to upload");
      }
      if (
        ![
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ].includes(file.type)
      ) {
        toast.error(
          "Invalid file format. Please upload a valid Excel file (.xlsx or .xls)."
        );
        return;
      }
      const extractedData = await ExtractData(file);

      const payload = {
        // type: ProductTypeSelected,
        products: [...extractedData],
        // contract_type_ids: selectedOption
        //   ? selectedOption.map((item) => item.value).join(",")
        //   : null,
      };

      postDataBULK(payload, onSuccess, onError);

      console.log("payload bulk", payload);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Card className="pt-3 pb-4 mt-5 mt-sm-0">
        <CardBody>
          <Row>
            <Col xs={12} className="mb-3">
              <Button variant="success" size="sm" onClick={handleDownload}>
                <IconFileTypeXls /> Download Template
              </Button>
            </Col>
          </Row>

          <Row className="mb-3 mt-3">
            <Form.Group as={Col}>
              <div
                style={{ display: "flex", gap: "2px 18px", flexWrap: "wrap" }}
              >
                <Form.Label
                  className="w-md-auto"
                  style={{ fontWeight: "bold" }}
                >
                  Product Type:
                </Form.Label>

                <Form.Check>
                  <Form.Check.Input
                    type="radio"
                    id="inventory"
                    value="inventory"
                    {...register("Type")}
                  />
                  <Form.Check.Label htmlFor="inventory">
                    Inventory
                  </Form.Check.Label>
                </Form.Check>

                <Form.Check>
                  <Form.Check.Input
                    type="radio"
                    id="non-inventory"
                    value="non-inventory"
                    {...register("Type")}
                  />

                  <Form.Check.Label htmlFor="RFIId">
                    Non-Inventory
                  </Form.Check.Label>
                </Form.Check>

                <Form.Check>
                  <Form.Check.Input
                    type="radio"
                    id="kit"
                    value="kit"
                    {...register("Type")}
                  />

                  <Form.Check.Label htmlFor="kit">Kit</Form.Check.Label>
                </Form.Check>
              </div>
            </Form.Group>
          </Row>

          <Row>
            <Col xs={12} className="mb-3">
              <Form.Group>
                <Form.Label>Select Contract Types</Form.Label>
                <Select
                  isMulti
                  defaultValue={selectedOption}
                  onChange={setSelectedOption}
                  className="basic-multi-select"
                  options={fetchContractdata?.data?.map((item, index) => ({
                    label: item?.name,
                    value: item?.id,
                  }))}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} className="mb-3">
              <Form.Group controlId="formFile">
                <Form.Label>Upload Excel File</Form.Label>
                <Form.Control
                  type="file"
                  accept=".xls,.xlsx,.xlsm"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <Button
                variant="warning"
                type="submit"
                onClick={() => {
                  handleExtractData();
                }}
              >
                Submit Excel
              </Button>
            </div>
          </Row>
        </CardBody>
      </Card>
    </>
  );
}

export default BulkPorduct;
